// import React from "react";
// import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa"; // Import icons

// const ChatButtons = () => {
//     const buttonStyle = {
//         position: "fixed",
//         right: "20px",
//         zIndex: "1000",
//         padding: "10px",
//         borderRadius: "50%",
//         boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
//         transition: "transform 0.3s ease-in-out",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         animation: "bounce 1.5s infinite", // Bouncing animation
//     };

//     const whatsappStyle = {
//         ...buttonStyle,
//         bottom: "70px",
//         backgroundColor: "#25d366",
//     };

//     const telegramStyle = {
//         ...buttonStyle,
//         bottom: "130px", // Placed above WhatsApp
//         backgroundColor: "#0088cc",
//     };

//     const iconStyle = {
//         width: "30px",
//         height: "30px",
//         color: "white"
//     };

//     return (
//         <>
//             {/* Telegram Button */}
//             <a
//                 href="https://t.me/sscpyqQuestions" // Replace with your Telegram link
//                 style={telegramStyle}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//                 onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             >
//                 <FaTelegramPlane style={iconStyle} />
//             </a>

//             {/* WhatsApp Button */}
//             <a
//                 href="https://whatsapp.com/channel/0029VayrxWv96H4M5AfWGJ46" // Replace with your WhatsApp link
//                 style={whatsappStyle}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//                 onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             >
//                 <FaWhatsapp style={iconStyle} />
//             </a>
//         </>
//     );
// };

// export default ChatButtons;

import React, { useState } from "react";
import {
    FaYoutube,
    FaTelegramPlane,
    // FaHandsHelping
    FaChevronUp,
    FaChevronDown,
} from "react-icons/fa"; // Import icons
import Donation from "./Donation"; // Import Donation Component
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const ChatButtons = () => {
    const [showDonation, setShowDonation] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const buttonStyle = {
        position: "fixed",
        right: "20px",
        zIndex: "1000",
        padding: "10px",
        borderRadius: "50%",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
        transition: "transform 0.3s ease-in-out",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: "bounce 1.5s infinite", // Bouncing animation
        cursor: "pointer",
    };

    const youtubeStyle = {
        ...buttonStyle,
        bottom: "70px",
        backgroundColor: "red",
        width: "30px",
        height: "30px"
    };

    const telegramStyle = {
        ...buttonStyle,
        bottom: "130px",
        backgroundColor: "#0088cc",
        width: "30px",
        height: "30px"
    };

    const toggleButtonStyle = {
        ...buttonStyle,
        bottom: "190px", // Above YouTube button
        backgroundColor: "#4a4a4a",
        width: "30px",
        height: "30px",
        animation: "colorChange 5s infinite alternate",
    };

    const iconStyle = {
        width: "30px",
        height: "30px",
        color: "white",
    };

    const quizStyle = {
        ...buttonStyle,
        bottom: "260px",
        // backgroundColor: "#25D366",
        opacity: isExpanded ? 1 : 0,
        transform: isExpanded ? "translateY(0)" : "translateY(20px)",
        pointerEvents: isExpanded ? "auto" : "none",
        flexDirection: "column", // Stack icon and text vertically
        width: "30px",
        height: "30px",
    };

    const flowchartStyle = {
        ...buttonStyle,
        bottom: "330px",
        // backgroundColor: "#25D366",
        opacity: isExpanded ? 1 : 0,
        transform: isExpanded ? "translateY(0)" : "translateY(20px)",
        pointerEvents: isExpanded ? "auto" : "none",
        flexDirection: "column", // Stack icon and text vertically
        width: "30px",
        height: "30px",
    };

    const englishStyle = {
        ...buttonStyle,
        bottom: "400px",
        // backgroundColor: "#25D366",
        opacity: isExpanded ? 1 : 0,
        transform: isExpanded ? "translateY(0)" : "translateY(20px)",
        pointerEvents: isExpanded ? "auto" : "none",
        flexDirection: "column", // Stack icon and text vertically
        width: "30px",
        height: "30px",
    };

    const textStyle = {
        position: "fixed",
        color: "black",
        fontSize: "10px",
        fontWeight: "bold",
        textAlign: "center",
        lineHeight: "1",
        bottom: "-12px",
    };

    return (
        <>
            {/* Donation Button */}
            {/* <div
                style={donateStyle}
                onClick={() => setShowDonation(true)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
                <FaHandsHelping style={iconStyle} />
            </div> */}
            <style>{`
    @keyframes colorChange {
        0% {
            background: linear-gradient(45deg, #FF9A8B, #FF6A88);
            box-shadow: 0 0 20px #FF6A88;
        }
        25% {
            background: linear-gradient(45deg, #FF6A88, #A78BFA);
            box-shadow: 0 0 25px #A78BFA;
        }
        50% {
            background: linear-gradient(45deg, #A78BFA, #8B5CF6);
            box-shadow: 0 0 30px #8B5CF6;
        }
        75% {
            background: linear-gradient(45deg, #8B5CF6, #3B82F6);
            box-shadow: 0 0 25px #3B82F6;
        }
        100% {
            background: linear-gradient(45deg, #3B82F6, #06B6D4);
            box-shadow: 0 0 20px #06B6D4;
        }
    }
`}</style>
            {/* ENGLISH */}
            <Link
                to="/quizCategory/english"
                style={englishStyle}
                // target="_blank" no new tab
                rel="noopener noreferrer"
                onMouseEnter={(e) => (e.currentTarget.style.transform = isExpanded ? "translateY(-5px) scale(1.1)" : "translateY(0)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = isExpanded ? "translateY(0) scale(1)" : "translateY(20px)")}
            >
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <img
                        src="https://icon-library.com/images/english-icon-png/english-icon-png-9.jpg"
                        alt="english"
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                        }}
                    />
                </div>
                <div style={textStyle}>English</div>
            </Link>
            {/* FLOWCHARTS */}
            <Link
                to="/blogsCategory" // React Router path
                style={flowchartStyle}
                // target="_blank" no new tab
                rel="noopener noreferrer"
                onMouseEnter={(e) => (e.currentTarget.style.transform = isExpanded ? "translateY(-5px) scale(1.1)" : "translateY(0)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = isExpanded ? "translateY(0) scale(1)" : "translateY(20px)")}
            >
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <img
                        src="https://img.icons8.com/bubbles/1200/mind-map.jpg"
                        alt="flowchart"
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                        }}
                    />
                </div>
                <div style={textStyle}>Mindmaps</div>
            </Link>
            {/* QUIZZES */}
            <Link
                to="/quizCategory"
                style={quizStyle}
                // target="_blank"  no new tab
                rel="noopener noreferrer"
                onMouseEnter={(e) => (e.currentTarget.style.transform = isExpanded ? "translateY(-5px) scale(1.1)" : "translateY(0)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = isExpanded ? "translateY(0) scale(1)" : "translateY(20px)")}
            >
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <img
                        src="https://media.istockphoto.com/id/1433122206/vector/question-bubbles-line-icon-vector.jpg?s=612x612&w=0&k=20&c=YOlrHcUKszzjlcU1lLc4XN-hJYUITbTauf1XrQr_PIk="
                        alt="WhatsApp"
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                        }}
                    />
                </div>
                <div style={textStyle}>Quizzes</div>
            </Link>

            <div
                style={toggleButtonStyle}
                onClick={() => setIsExpanded(!isExpanded)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
                {isExpanded ? (
                    <FaChevronDown style={iconStyle} />
                ) : (
                    <FaChevronUp style={iconStyle} />
                )}
            </div>

            {/* Telegram Button */}
            <a
                href="https://t.me/sscvidya_official"
                style={telegramStyle}
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
                <FaTelegramPlane style={iconStyle} />
            </a>

            <a
                href="https://www.youtube.com/@sscvidya"
                style={youtubeStyle}
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
                <FaYoutube style={iconStyle} />
            </a>

            {/* Show Donation Modal */}
            {showDonation && <Donation onClose={() => setShowDonation(false)} />}
        </>
    );
};

export default ChatButtons;

